var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full py-8 px-8"},[_vm._t("default"),(_vm.stats)?_c('stats',{attrs:{"stats":_vm.stats}}):_vm._e(),(_vm.arc)?_c('timeline',{attrs:{"arc":_vm.arc}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }